export type CollectionMotif = "ring" | "necklace" | "earring" | "bracelet";

export type Collection = {
  slug: string;
  name: string;
  intro: string;
  motif: CollectionMotif;
};

export const collections: Collection[] = [
  {
    slug: "rings",
    name: "Rings",
    intro: "Rings for everyday moments.",
    motif: "ring"
  },
  {
    slug: "necklaces",
    name: "Necklaces",
    intro: "Necklaces for everyday moments.",
    motif: "necklace"
  },
  {
    slug: "earrings",
    name: "Earrings",
    intro: "Earrings for everyday moments.",
    motif: "earring"
  },
  {
    slug: "bracelets",
    name: "Bracelets",
    intro: "Bracelets for everyday moments.",
    motif: "bracelet"
  }
];

export function getCollection(slug: string): Collection | undefined {
  return collections.find((collection) => collection.slug === slug);
}
